import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import * as userSlice from "../store/user"
import * as customerApis from "../utilities/apis/customer"
import GuestLayout from "../components/GuestLayout"

const Register = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (e) => {
    try {
      setLoading(true)
      e.preventDefault()

      const form = new FormData(e.target)

      const response = await customerApis.register(form)
      if (!response.status) throw new Error(response.message)

      navigate("/login")
    } catch (error) {
      alert(error.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <GuestLayout
      header={true}
      footer={false}
    >
      <main className="w-75 mx-auto">
        <div id="login" className="row">
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <div className="card rounded-4 shadow-none">
              <div className="card-body py-4">
                <div className="text-center mb-3">
                  <img src="/logo192.png" width={96} />
                </div>
                <div className="text-center mb-5">
                  <h3 className="text-body-emphasis fw-bold m-0">Phonics</h3>
                  <p className="lead fw-semibold text-body-secondary m-0">Register to Continue</p>
                </div>

                <form method="POST" onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="name" className="form-label">Name</label>
                    <input type="text" name="name" className="form-control rounded-3" id="name" required disabled={loading} />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="mobile" className="form-label">Mobile</label>
                    <input type="tel" name="mobile" className="form-control rounded-3" id="mobile" required disabled={loading} />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="address" className="form-label">Address</label>
                    <input type="text" name="address" className="form-control rounded-3" id="address" required disabled={loading} />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Password</label>
                    <input type="password" name="password" className="form-control rounded-3" id="password" required disabled={loading} />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="confirm" className="form-label">Confirm Password</label>
                    <input type="password" name="confirm" className="form-control rounded-3" id="confirm" required disabled={loading} />
                  </div>
                  <div className="mb-5">
                    <button type="submit" className="btn btn-theme rounded-3 w-100" disabled={loading}>Register</button>
                  </div>
                  <div className="text-center">
                    <p className="m-0">Already have an account? <Link to="/login" className="fw-semibold">Login now</Link></p>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="col-md-4"></div>
        </div>
      </main>
    </GuestLayout>
  )
}

export default Register
